const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	HEADER_HEIGHT: 70,
	TABLE_PAGE_SIZES: [15, 50, 100],
	DEFAULT_LANGUAGE: 'PL',
	SESSION_STORAGE_KEYS: {
		REFRESH_TOKEN: 'refreshToken',
		CONTENT: {
			PAGE: 'content-page',
			LIMIT: 'content-limit',
			SEARCH: 'content-search',
			SORT: 'content-sort',
		},
	},
} as const;

export default APP_CONFIG;
